// Import Packages
import React from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Close from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Divider from '@material-ui/core/Divider';

// Import Components
import JsonViewer from '../JsonViewer/JsonViewer';
import AttachVariable from '../AttachVariable/AttachVariable';
import { actionList } from '../Action/Action';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function AssignModal({
    showAssignModal,
    setShowAssignModal,
    variables,
    setOpenVariable,
    onVariableChange,
    onVariableIndexChange,
    showIndexInput,
    indexValue,
    setShowIndexInput,
    selectedVariable,
    assignValues,
    setAssignValues,
    setConfigureModal,
    saveAssign
}) {
    const { t } = useTranslation();
    const theme = useTheme();

    const fullWidth = useMediaQuery(theme.breakpoints.up('lg'));

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    // used for output variable assignment (set)
    const updateSetVariable = (index, e) => {
        let values = [...assignValues]; // make a separate copy of the array
        values[index].set = e.target.value;
        // update default fields
        values[index].manipulations.forEach((item, i) => {
            if (item.name) {
                let selectedAction = actionList[item.name]
                Object.keys(selectedAction.fields).forEach((key) => {
                    if (selectedAction.fields[key].defaultValue) {
                        values[index].manipulations[i].fields[key].value = selectedAction.fields[key].value.replace('-', e.target.value);
                    }
                })
            }
        })
        setAssignValues(values);
    }

    return (
        <Dialog open={showAssignModal} fullWidth={fullWidth}
            maxWidth={'lg'} aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle id="responsive-dialog-title">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <b style={{ borderBottom: '1px solid #bec0ca' }}> {t(label + 'HEADER')}</b>
                    <Button data-test="cancelautom-button" onClick={() => setShowAssignModal(false)}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>

            <DialogContent style={{ minHeight: '500px', maxHeight: '500px', padding: '0% 3% 3% 3%' }} >
                <Grid container >
                    <Grid item xs={5}>

                        <JsonViewer assignValues={assignValues} setAssignValues={setAssignValues} variables={variables}
                            setOpenVariable={setOpenVariable} include={["object"]} selectedVariable={selectedVariable}
                            onVariableChange={onVariableChange}
                            onVariableIndexChange={onVariableIndexChange} showIndexInput={showIndexInput}
                            setShowIndexInput={setShowIndexInput} indexValue={indexValue} />

                    </Grid>
                    <Grid item xs={1}>
                        <Divider style={{ marginLeft: '50%' }} orientation={'vertical'} />
                    </Grid>
                    <Grid item xs={6} >
                        <h2> {t(label + 'ASSIGN-MODAL-HEADER')}</h2>
                        <div style={{ fontSize: '13px', color: '#8C90A2', fontWeight: 700, marginBottom: '5px' }}>
                            {t(label + 'ASSIGN-MODAL-DESCRIPTION')}
                        </div>
                        {
                            assignValues?.map((value, index) => (
                                <AttachVariable variables={variables} value={value}
                                    setOpenVariable={setOpenVariable} include={'string'} updateSetVariable={updateSetVariable}
                                    setConfigureModal={setConfigureModal} assignIndex={index} />
                            ))
                        }

                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'space-between' }}>
                <Button
                    onClick={() => setShowAssignModal(false)}
                    variant="outlined"
                    style={{ backgroundColor: "#BBBBBB", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                    {t('CONTENT.MODAL.CANCEL')}
                </Button>
                <Button
                    onClick={saveAssign}
                    variant="outlined"
                    style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}>
                    {t('CONTENT.MODAL.SAVE')}
                </Button>
            </DialogActions>
        </Dialog >
    );
}
export default AssignModal;